import axios from "axios";
import { useQuery } from "react-query";

// Tournaments are public — no auth required to browse them.

// get all tournaments. `filters` maps onto the query params the public
// endpoint understands: search, status, country, category, dateFilter, page,
// limit. Passing none returns the whole calendar, as before.
const getTournaments = async (filters = {}) => {
  const params = Object.fromEntries(
    Object.entries(filters).filter(([, value]) => value !== "" && value != null)
  );
  const response = await axios.get("/api/v1/public/tournaments", { params });
  return response.data; // { success, count, totalPages, data: [...] }
};

export const useGetTournaments = (filters = {}) => {
  return useQuery(["tournaments", filters], () => getTournaments(filters), {
    keepPreviousData: true,
  });
};

// get tournament details — accepts an id or a slug
const getTournamentDetails = async (tournamentId) => {
  const response = await axios.get(
    `/api/v1/public/tournaments/${tournamentId}`
  );
  return response.data; // { success, data: {...} }
};

export const useGetTournamentDetails = (tournamentId) => {
  return useQuery(
    ["tournament", tournamentId],
    () => getTournamentDetails(tournamentId),
    { enabled: Boolean(tournamentId) }
  );
};
